import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { SpinnerComponent } from './components/spinner/spinner.component';
import { LoadingService } from './services/loading.service';
import { LanguageService } from './services/language.service';
import { ThemeService } from './services/theme.service';
import { iThemeTypes } from './interfaces/themes.interface';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    SpinnerComponent
  ],
  template: `
    <router-outlet />
    <app-spinner *ngIf="loading$ | async"  />
  `,
})

export class AppComponent implements AfterViewInit, AfterViewChecked {
  private loadingService = inject(LoadingService);
  private cdRef = inject(ChangeDetectorRef);
  private translate = inject(TranslateService);
  private languageService = inject(LanguageService);
  private themeService = inject(ThemeService);

  loading$ = this.loadingService.loading$;

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
    const lang = this.languageService.getLanguage();
    if (!lang()) {
      this.translate.setDefaultLang('pt-br');
      const selectedLanguage = this.translate.getBrowserLang();
      if (selectedLanguage === 'pt') {
        this.translate.use('pt-br');
        this.languageService.setLanguage('pt-br');
      } else {
        const language = selectedLanguage?.match(/pt-br|en|es|zh/) ? selectedLanguage : 'en';
        this.translate.use(language);
        this.languageService.setLanguage(language);
      }
    }
    const systemType = sessionStorage.getItem('systemType') as iThemeTypes;
    this.themeService.setThemeByThemeName(systemType);
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
}
